var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('AppLoader',{attrs:{"size":100,"color":"primary"}}):_vm._e(),_c('Header',{key:`${_vm.currentPerson.name}${_vm.user}`,attrs:{"user":_vm.user,"current":_vm.currentPerson}}),_c('NotificationContainer'),_c('router-view',{key:_vm.$route.fullPath}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }